// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveViewModal_container__ZrFOO {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 8px;
}

.SaveViewModal_formGroup__92muy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.SaveViewModal_formGroup__92muy label {
  font-weight: 500;
}

.SaveViewModal_preview__J1Wy\\+ {
  background: var(--background-color-1, #f9fafb);
  border: 1px solid var(--border-color-1, #e5e7eb);
  border-radius: 8px;
  padding: 16px;
}
.SaveViewModal_previewTitle__Dl0ld {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--text-color-3, #9ca3af);
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.05em;
}

.SaveViewModal_tags__7MO-Z {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SaveViewModal/SaveViewModal.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,8CAAA;EACA,gDAAA;EACA,kBAAA;EACA,aAAA;AAAF;AAEE;EACE,eAAA;EACA,yBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AADF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-top: 8px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    font-weight: 500;\n  }\n}\n\n.preview {\n  background: var(--background-color-1, #f9fafb);\n  border: 1px solid var(--border-color-1, #e5e7eb);\n  border-radius: 8px;\n  padding: 16px;\n\n  &Title {\n    font-size: 12px;\n    text-transform: uppercase;\n    color: var(--text-color-3, #9ca3af);\n    font-weight: 600;\n    margin-bottom: 12px;\n    letter-spacing: 0.05em;\n  }\n}\n\n.tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SaveViewModal_container__ZrFOO`,
	"formGroup": `SaveViewModal_formGroup__92muy`,
	"preview": `SaveViewModal_preview__J1Wy+`,
	"previewTitle": `SaveViewModal_previewTitle__Dl0ld`,
	"tags": `SaveViewModal_tags__7MO-Z`
};
export default ___CSS_LOADER_EXPORT___;
